<template>
  <div class="highlight" :key="value">{{ valueFormated }}</div>
</template>

<script>
export default {
  name: "NumberView",
  props: {
    value: Number
  },
  computed: {
    valueFormated() {
      return new Intl.NumberFormat('sv-SE').format(Math.round(this.value))
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.highlight {
  animation: glow 700ms 2;
  border-radius: 3px;
  display: inline-block;
  padding: 2px 5px;
}

@keyframes glow {
  50% {
    background: rgba(255,255,0,0.5);
    box-shadow: 0 0 10px yellow;
    font-weight: bold;
  }
}
</style>
